import { TABLES } from '@/utils/constants';
import { getRecords } from '@/utils/helpers/data';
import { DENTIST_HOUR_COLUMNS, DentistHour } from '@/utils/schema';

export type { DentistHour };
export const COLUMNS = DENTIST_HOUR_COLUMNS;

/**
 * Retrieves all dentist hours associated with a specific dentist ID.
 * @param dentistId - The ID of the dentist.
 * @returns An array of dentist hours.
 */
export const getDentistHoursByDentistId = (dentistId: string) =>
  getRecords<DentistHour>(TABLES.DENTIST_HOURS, COLUMNS.DENTIST_ID, dentistId);
